export type EndorsementStatus = "pending" | "approved" | "rejected";

export const ENDORSEMENT_STATUS_LABEL: Record<EndorsementStatus, string> = {
  pending: "Pendente",
  approved: "Aprovado",
  rejected: "Recusado",
};

export type EndorsementFile = {
  id: number;
  file_name: string;
  mime_type: string | null;
  is_video: boolean;
  size: number;
  created_at: string;
  created_by: { id: number; name: string } | null;
  url: string;
};

export type EndorsementProduct = {
  name: string;
  contest: string | null;
  lottery: string | null;
  lottery_color: string | null;
  quantity: number;
};

export type Endorsement = {
  id: number;
  uuid: string;
  sale_id: number;
  sale_uuid: string | null;
  status: EndorsementStatus;
  client_name: string;
  client_document: string;
  description: string | null;
  reviewer_notes: string | null;
  reviewed_at: string | null;
  created_at: string;
  seller_name: string | null;
  reviewer_name: string | null;
  tickets_quantity: number;
  total_value: number;
  products: EndorsementProduct[];
  files: EndorsementFile[];
};

export type EndorsementPrefill = {
  sale_id: number;
  client_id: number;
  client_name: string | null;
  client_document: string | null;
  has_active_request: boolean;
};

export type EndorsementTotals = {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
  tickets_quantity: number;
  total_value: number;
};
